<template>
  <Form
    @submit="onSubmit"
  >
    <InputBlock
      prop="tickets"
      :label="hasTicketingTypes ? props.section.$t('poly.ticket.label') : undefined"
      :class="hasTicketingTypes ? '' : 'mb-0'"
    >
      <div
        v-if="hasTicketingTypes"
        class="flex flex-col gap-2 w-full"
        role="radiogroup"
      >
        <PageFormBasicTicketsTicket
          v-for="ticketingType in props.ticketingTypes"
          :key="ticketingType.id"
          v-model:selected-ticket-types="selectedTicketTypes"
          :ticketing-type="ticketingType"
          :lang="lang"
          :form="props.form"
          :guest="props.guest"
          :event="props.event"
          :section="props.section"
        />
      </div>
      <div
        v-else
        class="text-sm text-gray-500 text-center py-4 w-full"
      >
        <EmptyState
          icon="ticket-01"
          :title="props.section.$t('poly.tickets.notAvailable')"
        />
      </div>
    </InputBlock>

    <Button
      v-if="hasTicketingTypes"
      type="primary"
      size="large"
      class="w-full"
      native-type="submit"
      :disabled="!isMounted || !selectedTicketTypes.length"
    >
      {{ section.$t('poly.continue') }}
    </Button>
  </Form>
</template>

<script setup>
const props = defineProps({
  selectedTicketTypes: {
    type: Array,
    default: () => [],
  },
  ticketingTypes: {
    type: Array,
    required: true,
  },
  event: {
    type: Object,
    required: true,
  },
  lang: {
    type: String,
    required: true,
  },
  form: {
    type: Object,
    required: true,
  },
  guest: {
    type: Object,
    default: null,
  },
  section: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['submit', 'update:selectedTicketTypes']);

// Refs
const isMounted = useMounted();
const selectedTicketTypes = useVModel(props, 'selectedTicketTypes', emit);

// Computed
const hasTicketingTypes = computed(() => Boolean(props.ticketingTypes?.length));

// Methods
const onSubmit = () => {
  emit('submit');
};
</script>
